import React, { useEffect, useState } from "react";
import { Translator } from './translator';

const NFTClub = () => {
    const { translateText, lang } = Translator();

    const baseText = {
        text1: "NFTteche Club",
        text2: `Benvenuto nel Club NFTteche, dove Innovazione e Culture si incontrano!
                    In NFTteche crediamo che tecnologia, culture e comunità possano unirsi per creare qualcosa di veramente straordinario.
                    Il Club NFTteche è una community esclusiva dedicata a coloro che vogliono far parte della rivoluzione NFT da una posizione privilegiata.`,
        text3: "Cos'è NFTteche?",
        text4: "NFTteche non è solo una collezione di NFT. È un movimento. Un ecosistema digitale che unisce patrimonio culturale, collezionisti e innovatori nel mondo della tecnologia blockchain. NFTteche sta costruendo il futuro dello spazio NFT: Valore – Scarsità – Utilità nel lungo termine.",
        text5: "Il Club NFTteche premia i membri che partecipano attivamente al successo del progetto NFTteche con accesso anticipato, privilegi, sconti e premi esclusivi.",
        text6: "Come si entra a far parte del Club NFTteche?",
        text7: "Entrare a far parte del Club NFTteche è facile!",
        text8: "Cosa fare:",
        text9: "Seguici: Rimani connesso tramite i nostri canali ufficiali sui social media e unisciti a noi nella riscoperta e conservazione del nostro Patrimonio Culturale Territoriale.",
        text10: "Condividi con i tuoi amici: Aiutaci a diffondere il messaggio su NFTteche.",
        text11: "Approfitta delle esperienze di gamification per ottenere vantaggi, sconti, offerte e NFT rari.",
        text12: "Unisciti alla Whitelist: sii tra i primi nella prossima uscita di NFTteche.",
        text13: "Possiedi NFTteche! Avere determinati NFTteche delle nostre prime due collezioni potrebbe garantirti lo status privilegiato di membro del club e l’accesso prioritario alle prevendite delle collezioni successive.",
        text14: "Il Futuro di NFTteche:",
        text15: "La nostra visione per NFTteche va oltre: si tratta di creare uno spazio digitale in cui Culture, Comunità e Tecnologia prosperano insieme. Con il tuo supporto, continueremo a evolverci e a spingere oltre i confini della Conoscenza nel mondo degli NFT e della blockchain.",
        text16: "Rimani aggiornato per notizie entusiasmanti, partnership e collaborazioni che renderanno NFTteche la destinazione principale per appassionati di Patrimonio Culturale, studiosi d’arte, italiani nel mondo che vogliono riscoprire le proprie radici, collezionisti/investitori di NFT, tecnofili, millennial e appassionati di gamification!",
        text17: "Consulta il Regolamento di NFTteche nella nostra sezione dedicata.",

    };

    const [translatedText, setTranslatedText] = useState(baseText);
    useEffect(() => {
    const translateAll = async () => {
        const entries = Object.entries(baseText);
        const translatedEntries = await Promise.all(
        entries.map(async ([key, value]) => [key, await translateText(value)])
        );
        setTranslatedText(Object.fromEntries(translatedEntries));
    };

    translateAll();
    }, [lang]);

    return (
        <div className="flex flex-col justify-center items-center w-full min-h-screen bg-[#F2F2F2]">
            <img 
                src="https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/Teche/NFT/COPERTINA-NFT.jpg" 
                alt="Copertina NFT Teche"
                className="max-w-full h-auto mb-8"
            />
            <div className="text-black text-justify max-w-[50rem] mx-auto leading-relaxed text-[1.0625rem] whitespace-pre-line space-y-4 mb-16">
            
                <h1 className="text-2xl font-bold mb-2">{translatedText.text1}</h1>
                <p>
                    {translatedText.text2}
                    
                </p>
                <h2 className="text-xl text-black font-semibold mt-4">{translatedText.text3}</h2>
                <p>
                    {translatedText.text4}
                </p>
                <p>
                    {translatedText.text5}
                </p>
                <h2 className="text-xl text-black font-semibold mt-4">{translatedText.text6}</h2>
                <p>{translatedText.text7}</p>
                <p><strong>{translatedText.text8}</strong></p>
                <ul className="list-disc list-outside ml-4 space-y-1">
                    <li>{translatedText.text9}</li>
                    <li>{translatedText.text10}</li>
                    <li>{translatedText.text11}</li>
                    <li>{translatedText.text12}</li>
                    <li>{translatedText.text13}</li>
                </ul>
                <h2 className="text-xl text-black font-semibold mt-4">{translatedText.text14}</h2>
                <p>
                    {translatedText.text15}
                </p>
                <p>
                    {translatedText.text16}
                </p>
                <p>
                    {translatedText.text17}
                </p>
            </div>
        </div>
    );
};

export default NFTClub;